<template>
    <div>
         <!-- main-area -->
         <main class="fix">
                <!-- breadcrumb-area -->
                <section class="breadcrumb__area breadcrumb__bg">
                    <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="breadcrumb__content">
                                    <h2 class="title">{{$route.name}}</h2>
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href="javascript:void(0);">Unit Kerja</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">{{$route.name}}</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="breadcrumb__shape">
                        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                    </div>
                </section>

                <section class="about__area-five about__area-seven">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="about__content-five ">
                                        
                                        
                                        <p class="" v-html="uraian"></p>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="about__shape-wrap-four">
                            <img src="assets/img/images/h4_about_shape01.png" alt="">
                            <img src="assets/img/images/h4_about_shape02.png" alt="" data-parallax='{"x" : -80 , "y" : -80 }'>
                        </div>
                    </section>
                    <!-- about-area-end -->
                <!-- breadcrumb-area-end -->
               
                
            </main>
            <!-- main-area-end -->
    
    
    </div>
    </template>

    <script>

        export default {

            data() {
                return {
                    uraian: "",
                    kategori: "Pembinaan dan Pengembangan Kawasan Transmigrasi",
                }
            },
            methods: {
                getView: function() {
                    fetch(this.$store.state.ADD_URL_UNIT_KERJA + "view", {
                        method: "POST",
                        headers: {
                        "content-type": "application/json",
                        },
                        body : JSON.stringify({
                            kategori: this.kategori,
                        }),
                    })
                        .then(res => res.json())
                        .then(res_data => {
                            // console.log(res_data);
                            
                        // this.uraian = res_data[0].uraian;
                        this.uraian = res_data?.[0]?.uraian ? res_data[0].uraian : "";

                        })
                        .catch(err => {
                            console.error("Error:", err);
                            this.uraian = ""; // fallback kalau fetch gagal
                        });                        
                },
                    

            // ================== PAGINASI ====================
          
            // ================== PAGINASI ====================
            },
            // =============================================================== METHODS =========================================================================

            mounted() {

            this.getView();
                
            }
            };



    </script>


<style scoped>
.about__content-five *
{
    font-size: 12px !important;
}
:deep(.halaman), :deep(.halaman *) {
  all: unset;
  display: revert;
  box-sizing: border-box;
}

/* Setelah di-reset, buat style kamu sendiri */
.halaman {
  font-family: sans-serif;
  color: #333;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
}
</style>
